const modalSettings = {
  fadeDuration: 250,
  fadeDelay: 0.80,
};

export default modalSettings;
